module.exports = __webpack_public_path__ + "static/media/menu-magestore-logo.440f680a.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/style/images/menu-magestore-logo.png
// module id = 2624
// module chunks = 0